import { IRootState, RootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { ISettingsService, SettingsService } from '@/services';

export interface ISettingsState<TService = any> extends IRootState<ISettingsService> {
}
export class SettingsState extends RootState implements ISettingsState<ISettingsService> {
  /**
   *
   */
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new SettingsService;
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/settings-state.store.ts